import React, { useEffect, useState } from "react";
import "./index.scss"; // Assurez-vous que le fichier CSS est bien lié
import Rating from "@mui/material/Rating";
import "bootstrap-icons/font/bootstrap-icons.css";
import { showErrorToaster } from "../toaster/error";
import MissionService from "../../services/mission/mission.service";
import StickyButton from "../StickyButton";
import Modal from "../modal";
import { showSuccessToaster } from "../toaster/success";
import CandidatureService from "../../services/candidature/condidature.service";
const candidatureService = new CandidatureService();
const missionService = new MissionService();
const JobList = () => {
  const [mission, setMission] = useState([]);
  const loadData = async () => {
    try {
      const res = await missionService?.getAllActiveMission();
      setMission(res?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const [showModal, setShowModal] = useState(false);


  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

 


  return (
    <div className="top-con">
      <section className="container mt-job">
        <div className="row mt-4 mb-5">
          {mission.map((missio) => (
            <div className="col-lg-4  p-4">
              <div className="card-j">
                <div className="card-header-j p-3">
                  <h3>{missio?.title}</h3>
                  <div className="rating  d-flex   flex-wrap mt-2 gap-2">
                    <Rating
                      defaultValue={4}
                      readOnly
                      className="black-rating"
                    />
                    <a href="#">(42 Reviews)</a>
                  </div>
                  <p>
                    <i className="bi bi-geo-alt"></i>
                    {missio?.paye}
                  </p>
                  <div className="card-tags-j">
                    <span className="tag">{missio?.typeContrat}</span>
                    <span className="tag">{missio?.level}</span>
                    <span className="tag">{missio?.typeWork}</span>
                  </div>
                </div>

                <div className="card-footer-j d-flex  flex-wrap p-2 pb-0 pt-3">
                  <p>
                    €{missio?.salaire}
                    <span>/Mois</span>
                  </p>
                  <button onClick={openModal} className="open-modal-btn">
                    Appliquez
                  </button>
                  <Modal
                    showModal={showModal}
                    handleClose={closeModal}
                    missionId={missio?.id}
             
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <StickyButton />
    </div>
  );
};

export default JobList;
